import { BalanceRow } from 'pages/Finance/BalanceReport/components/BalanceReportDatagrid/BalanceReportDatagrid';
import { CompanyBalanceReport } from 'types/embedded/balanceReport';

export const flattenBalanceData = (companies: CompanyBalanceReport[]): BalanceRow[] => {
  const rows: BalanceRow[] = [];

  companies.forEach((company, index) => {
    const companyId = `company-${company.id}`;

    rows.push({
      id: companyId,
      level: 0,
      type: 'company',
      name: company.name,
      amountData: company.amountData,
      index,
    });

    company.merchants.forEach((merchant, index) => {
      const merchantId = `${companyId}-merchant-${merchant.id}`;

      rows.push({
        id: merchantId,
        parentId: companyId,
        level: 1,
        type: 'merchant',
        name: merchant.name,
        amountData: merchant.amountData,
        index,
      });

      merchant.providers.forEach((provider, index) => {
        const providerId = `${merchantId}-provider-${provider.id}`;
        rows.push({
          id: providerId,
          parentId: merchantId,
          level: 2,
          type: 'provider',
          name: provider.name,
          firstTransactionAt: provider.firstTransactionAt,
          amountData: provider.amountData,
          index,
        });

        provider.merchantAccounts.forEach((account, index) => {
          const accountId = `${providerId}-account-${account.id}`;

          rows.push({
            id: accountId,
            parentId: providerId,
            level: 3,
            type: 'account',
            name: account.name,
            currencyCode: account.currencyCode,
            firstTransactionAt: account.firstTransactionAt,
            amountData: account.amountData,
            company,
            merchant,
            provider,
            merchantAccount: account,
            index,
          });
        });
      });
    });
  });

  return rows;
};
